define("settings/components/restricted-page", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Card class="tAC--card qa--nonAccountOwner_restricted_modal" data-test-id="restricted-page">
    <div class="o--blankWrapper">
      <div class="o--blank">
        <div class="img--empty"></div>
        <h2 class="o--blank__title">
          {{or @title (t "account.restricted_page.title")}}
        </h2>
        <p class="o--blank__desc">
          {{@description}}
        </p>
      </div>
    </div>
  </Shared::Card>
  */
  {
    "id": "ZSFnzK+w",
    "block": "[[[8,[39,0],[[24,0,\"tAC--card qa--nonAccountOwner_restricted_modal\"],[24,\"data-test-id\",\"restricted-page\"]],null,[[\"default\"],[[[[1,\"\\n  \"],[10,0],[14,0,\"o--blankWrapper\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"o--blank\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"img--empty\"],[12],[13],[1,\"\\n      \"],[10,\"h2\"],[14,0,\"o--blank__title\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[[30,1],[28,[37,2],[\"account.restricted_page.title\"],null]],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,2],[14,0,\"o--blank__desc\"],[12],[1,\"\\n        \"],[1,[30,2]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]]]]]],[\"@title\",\"@description\"],false,[\"shared/card\",\"or\",\"t\"]]",
    "moduleName": "settings/components/restricted-page.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});